<template>
  <div class="ma-4">
    <v-snackbar v-model="msg" top>
      {{ text }}
      <v-btn color="pink" text @click="msg = false"> Close</v-btn></v-snackbar
    >
    <!-- <adl-view ref="adl" /> -->
    <v-card>
      <v-layout row wrap class="pa-2 ma-2 hideOnPrint">
        <v-flex xs10>
          <v-btn fab x-small @click="$router.go(-1)">
            <v-icon>navigate_before</v-icon>
          </v-btn>
        </v-flex>        
                
        <v-flex xs2>
          <report-list-actions
          :reportOptions="reportOptions"
          :downloadFilename="reportListFilename"
          ></report-list-actions>
      </v-flex>

        <v-flex xs12>
          <h3 class="text-center mb-5">Client ADL Report</h3>
          <v-divider class="ml-4 mr-4 mb-3"></v-divider>
        </v-flex>

        <v-flex xs12>
          <v-card class="ma-3 pa-3" elevation="0">
            <v-layout row wrap>
              <v-flex xs12 md2 class="pa-1">
                <v-menu
                  v-model="calendarMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="reportFilters.startDate"
                      label="Start Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="requiredField"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="reportFilters.startDate"
                    @input="calendarMenu = false"
                    no-title
                    :rules="requiredField"
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs12 md2 class="pa-1">
                <v-menu
                  v-model="calendar2Menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="reportFilters.endDate"
                      label="End Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="reportFilters.endDate"
                    @input="calendar2Menu = false"
                    no-title
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <!-- <v-flex xs12 md2 class="pa-1 mb-2">
                <v-select
                  label="Signed/Unsigned"
                  :items="status"
                  item-text="Name"
                  item-value="Name"
                  v-model="selectedStatus"
                  clearable
                  @change="adlQuery"
                ></v-select>
              </v-flex> -->

              <!-- <v-flex xs12 md2 class="pa-1 mb-2">
                <v-select
                  label="Select a Program"
                  :items="programs"
                  item-text="Name"
                  item-value="Name"
                  v-model="program"
                  clearable
                ></v-select>
              </v-flex> -->


              <v-flex xs12 md2  class="pa-1 mb-2">
                <v-select
                  label="Client Status"
                  :items="clientStatuses"
                  v-model="reportFilters.clientStatus"
                  clearable
                  ></v-select>
              </v-flex>

              <v-flex xs12 md2 class="pa-1 mb-2">
                <v-select
                  label="Select a Client"
                  :items="filteredClients"
                  item-text="Name"
                  item-value="_id"
                  v-model="reportFilters.ClientID"
                  clearable
                  @change="adlQuery()"
                ></v-select>
              </v-flex>

              <v-flex xs12 md2 class="pa-1 mb-2" v-if="reportFilters.ClientID != ''">
                <v-select
                  label="Select Client ADL"
                  :items="clientADLs"
                  item-text="serviceItemType"
                  item-value="serviceItemType"
                  v-model="clientADL"
                  :loading="isLoadingService"
                  clearable
                  return-object
                ></v-select>
              </v-flex>

              <v-flex xs12 md1 class="mt-5 mb-5 pl-5">
                <v-btn small @click="adlQuery()">Search</v-btn>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>

        <v-flex xs12 class="pa-2">
          <v-data-table
            :page="page"
            :pageCount="pageCount"
            :server-items-length="itemCount"
            :options.sync="options"
            :headers="headers"
            :items="adls"
            sort-by="Date"
            sort-asc
            class="elevation-1 custom-table"
            :loading="isLoading"
            loading-text="Loading ADLS"
          >
            <template v-slot:item.Time="{ item }">
              <div class="cell-content">
                {{ item.Time }}
              </div>
            </template>
            <template v-slot:item.status="{ item }">
              <v-chip
                class="ma-2"
                :color="item.status === 'Unsigned' ? 'yellow' : 'green'"
                x-small
              >
                <span
                  :class="
                    item.status === 'Unsigned' ? 'black--text' : 'white--text'
                  "
                  >{{ item.status }}</span
                >
              </v-chip>
            </template>

            <template v-slot:item.select="{ item }">
              <v-btn
                x-small
                class="white--text"
                color="#2b3990"
                @click="viewADL(item)"
              >
                view
              </v-btn>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-card>

    <v-dialog v-model="dialog" max-width="75%">
      <v-card>
        <v-card-title style="background-color: #2b3990">
          <span class="headline white--text">{{ titleForm }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="newService"
                    label="Service"
                    :disabled="true"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="newTime"
                    label="ADL Time"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-select
                    v-model="newAssistance"
                    label="Level of Assistance"
                    :items="assistance"
                    :rules="requiredRules"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-autocomplete
                    v-model="newException"
                    label="Exception"
                    :items="exception"
                    :rules="requiredRules"
                  ></v-autocomplete>
                </v-col>
                <v-col class="d-flex" cols="6" sm="6">
                  <v-textarea v-model="newNotes" label="Notes"></v-textarea>
                </v-col>
                <v-col
                  class="d-flex"
                  cols="6"
                  sm="6"
                  style="position: relative"
                >
                  <v-text-field
                    class="update-icon"
                    v-model="newSignature"
                    label="Signature"
                    append-icon="mdi-pencil-box-outline"
                    @click:append="onUpdateSignature()"
                    v-if="canUpdate"
                  ></v-text-field>
                  <v-text-field
                    class="update-icon"
                    v-model="newSignature"
                    label="Signature"
                    readonly
                    disabled
                    v-if="!canUpdate"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn class="blue darken-2 white--text" text @click="addADL()" v-if="newService">Save</v-btn
                                > -->
          <v-btn color="blue darken-1" text @click="onUpdateItem" v-if="editADL"
            >Update</v-btn
          >
          <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div id="print">
      <report-header>
        <h2>ADL Report</h2>
      </report-header>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="adls"
            sort-by="Date"
            sort-asc
            class="elevation-1"
            :loading="isLoading"
            loading-text="Loading ADLS"
            :items-per-page="-1"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";
// import Foot from '../components/Footer'
// import AdlView from "@/components/serviceplan/adl/AdlView";
import { setUserTz, tz } from "../../../utils/timezone";
import ReportHeader from '@/components/Report/ReportHeader.vue';
import { STATUS_ARRAY } from '../../enums/UserStatusEnum';
import ReportListActions from '@/components/Report/ReportListActions.vue';
import ReportFilters from '@/mixins/reportFilters.js';

const url = require("../../client_config/config").url;

export default {
  props: {
    itemData: {
      type: Object,
    },
    updatedSignature: {
      type: String,
    },
  },
  mixins: [ReportFilters],
  components: {
    // AdlView,
    ReportHeader,
    ReportListActions
  },
  data: () => ({
    headers: [
      {
        text: "Date",
        align: "start",
        sortable: true,
        value: "date.formatted",
      },
      { text: "Client", value: "client.name" },
      { text: "Service", value: "service.item" },
      { text: "Type", value: "Service.type" },
      { text: "Event Time", value: "Time" },
      { text: "Support Strategy", value: "service.support" },
      { text: "Human Rights", value: "service.rights" },
      { text: "Notes", value: "service.notes" },
      { text: "Signature", value: "staff.signature" },
    ], 

    // date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
    //   .toISOString()
    //   .substr(0, 10),
    clients: [],
    adls: [],
    programs: [],
    temp: [],
    status: ["Signed", "Unsigned"],
    selectedStatus: "",
    startDate: "",
    endDate: "",
    ClientID: "",
    calendarMenu: false,
    calendar2Menu: false,
    report: "",
    clientName: "",
    isLoading: false,
    program: "",
    userState: localStorage.getItem("userState"),
    states: ["Utah", "Nevada"],
    isUtahIncidentReports: true,
    requiredField: [(v) => !!v || "This is required"],
    model: "tab-2",
    text: "",
    dialog: false,
    assistance: [
      "Independant",
      "Minimal Assistance",
      "Moderate Assistance",
      "Total Assistance",
    ],
    exception: ["Refused", "ADL on Hold", "Absent", "Other"],
    titleForm: "Viewing Unsigned ADL",
    newService: "",
    newTime: "",
    newAssistance: "",
    newException: "",
    newNotes: "",
    editADL: false,
    newSignature: "",
    adlID: "",
    msg: "",
    requiredRules: [(v) => !!v || "This is required"],
    clientADLs: [],
    clientADL: "",
    options: {},
    page: 1,
    pageCount: 1,
    itemCount: 0,
    isLoadingService: true,
    clientStatus: "",
    clientStatuses: STATUS_ARRAY,
    reportFilters:  {
      startDate: '',
      endDate: '',
      ClientID: '',
      clientStatus: '',
      clientADL: ''
    },
    reportFilterName: 'ReportFilters_AllADL'

  }),

  watch: {

    reportFilters: {
        handler(newVal) {
            this.setReportFilters(this.reportFilterName, newVal);
        },
        deep: true
    }

  },

  computed: {
    ...mapGetters("timezones", ["getUserTimezone", "getDefaultTz"]),

    userTimezone() {
      const data = {
        userTimezone: this.getUserTimezone,
        defaultTz: this.getDefaultTz,
      };
      return setUserTz(data);
    },
    
    filteredClients() {
      let clients = this.clients;
      
      if (this?.clientStatus != "" && this.reportFilters.clientStatus) {
        clients = clients.filter((client) => client.Status == this.reportFilters.clientStatus)
      }
      
      return clients;
    },
    
    queryParams() {
      let {page, sortBy, sortDesc, itemsPerPage} = this.options;      
      const sortField = sortBy ? sortBy[0] : 'Date';
      const sortDirection = sortDesc ? sortDesc[0] : 'desc';

      return {
          startDate: this.reportFilters.startDate || "",
          endDate: this.reportFilters.endDate || "",
          clientId: this.reportFilters.ClientID || "",
          clientAdl: this.reportFilters.clientADL || "",
          state: this.userState || "",
          page: page,
          limit: itemsPerPage,
          sortField: sortField,
          sortDirection: sortDirection,
          tz: this.getDefaultTz,
          clientStatus: this.reportFilters.clientStatus,
          clientADL: {
            ServiceItem: this.clientADL?.ServiceItem,
            Type: this.clientADL?.Type
          }
        };
    },

    reportOptions() {
      return { 
          query: this.queryParams,
          endpoints: `adl/report/printList`,
          dynamic: true,
      }
    },
    reportListFilename() {
      return `Client ADL Report`
    }
  },

  mounted() {
    // Only watch the options property after the page has been loaded/mounted
    // to not the trigger the paginated fetching upon page load
    this.$watch(
      "options",
      () => {
        this.adlQuery();
      },
      { deep: true }
    );
  },

  created() {
    this.getClients();
    this.getPrograms();
    // this.adlQuery();
    this.reportFilters = this.getReportFilters(this.reportFilterName) ?? this.reportFilters;
  },

  methods: {
    initialize() {
      this.clients = [];
    },

    canUpdate() {
      if (
        localStorage.getItem("userRole") == "Administration" ||
        localStorage.getItem("userRole") == "Program Coordinator" ||
        localStorage.getItem("userRole") == "Client Services Manager" ||
        localStorage.getItem("userRole") == "Medical Manager" ||
        localStorage.getItem("userRole") == "Compliance Manager" ||
        localStorage.getItem("userRole") == "Human Resources"
      ) {
        return true;
      }
      return false;
    },

    getClients() {
      // axios.get(`${url}/clients/state/${this.userState}`).then(async (res) => {
      //   this.clients = res.data.clients;
      // });
      axios.get(`${url}/clients/`).then(async (res) => {
        this.clients = res.data.clients;
      });
    },

    getPrograms() {
      axios.get(`${url}/units/state/${this.userState}`).then(async (res) => {
        this.programs = res.data.units;
      });
    },

    close() {
      this.dialog = false;
    },

    async adlQuery() {
      try {
        this.isLoading = true;
        this.clientADLs = [];

        const params = this.queryParams;

        let endpoint = `${url}/adl/report`;

        const response = await axios.get(endpoint, { params });
        this.clientADLs = await this.getClientADLs(this.reportFilters.ClientID);

        const { results, pagination } = response.data;

        this.pageCount = pagination.limit;
        this.itemCount = pagination.total;
        this.adls = results;



        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },

    async getClientADLs(id) {
      try {
        this.isLoadingService = true;
        const response = await axios.get(`${url}/ServicePlans/client/${id}`);

        const serviceItemType = response.data.services
          .map((item) => ({
            ...item,
            serviceItemType: `${item.Type} - ${item.ServiceItem}`,
          }))
          .filter((item) => item.Active === "Active");

        this.isLoadingService = false;

        return serviceItemType;
      } catch (err) {
        this.isLoadingService = false;
        console.error("Error".err);
      }
    },

    onUpdateItem() {
      var data = {
        Date: this.newDate,
        Time: this.newTime,
        Assistance: this.newAssistance,
        Exception: this.newException,
        Notes: this.newNotes,
        ClientID: this.clientID,
        Signature: this.newSignature,
        UrlNotification: this.$router.history.current.path,
      };
      axios.put(`${url}/adl`, data).then((res) => {});
    },

    viewADL(item) {
      console.log(item + " item");
      // this.editADL = true;
      this.dialog = true;
      this.newService = item.services.ServiceItem;
      this.newTime = item.services.ScheduledTime;
      this.newAssistance = item.services.Assistance;
      this.newException = item.services.Exception;
      this.newNotes = item.services.Notes;
      this.newSignature = item.services.Signature;
      this.adlID = item._id;
    },

    onUpdateSignature() {
      this.$emit("updateSignature");
      this.$nextTick(() => {
        this.newSignature = this.updatedSignature;
      });
    },

    printTable() {
      window.print();
    },
  },
};
</script>
<style>
.custom-table .v-data-table__cell {
  min-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
#print {
  display: none;
}

@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}

@media only screen and (min-width: 768px) {
  .mobile {
    display: none;
  }
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
}

@media print {
  #print {
    display: block;
    border: none;
    width: 1200px;
    padding-right: 300px;
    margin-left: -200px;
  }

  nav.v-navigation-drawer,
  header.v-toolbar,
  button.v-btn,
  div.v-card {
    display: none;
    border: none;
  }

  @page {
    margin: 0;
  }
  body {
    margin: 1.6cm;
  }
}
</style>
